import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListaContactos } from 'src/app/interfaces/ListaContactosData';
import { ListaContactosService } from 'src/app/service/listaContactos.service';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
//import { error } from 'console';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-crear-contactos',
  templateUrl: './crear-contactos.component.html',
  styleUrls: ['./crear-contactos.component.scss'],
  providers: [MessageService]
})
export class CrearContactosComponent implements OnInit{
  
  deviceUrl: string = '';
  deviceName: string = '';
  nuevaLista: ListaContactos = {
    nombre: '',
    tipoLista: 'enviar-mensaje-muchos-contactos',
    lista: '',
    token: '',
    id: '',
    updated_at: 0
  };

  validar: boolean = false;

  archivoSeleccionado: File | null = null;

  ingresoManualSeleccionado: boolean = true;
  importacionCsvSeleccionada: boolean = false;

  soloNumerosValidacion: RegExp = /^[0-9\s]+$/;

  constructor(private messageService: MessageService,  private route: ActivatedRoute, 
    private contactosService: ListaContactosService, private formBuilder: FormBuilder,
     private router: Router, private translate: TranslateService) { 
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
     }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['deviceUrl'] || '';
      const nombre = params['deviceName'] || '';
      if (token) {
        this.deviceUrl = token;
      } 
      if(nombre){
        this.deviceName = nombre;
      }
    });
    this.opcionSeleccionada();
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  // Método para manejar la selección de archivos
  onFileSelected(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.archivoSeleccionado = fileList[0];
    }
  }
  
  opcionSeleccionada(){
    if(this.ingresoManualSeleccionado){
      this.importacionCsvSeleccionada = false;
    } else if(this.importacionCsvSeleccionada){
      this.ingresoManualSeleccionado = false;
    }
  }

  // Función para manejar el cambio en la selección de opciones
  cambioSeleccion(option: number) {
    if (option === 1) {
      this.ingresoManualSeleccionado = true;
      this.importacionCsvSeleccionada = false;
    } else if (option === 2) {
      this.ingresoManualSeleccionado = false;
      this.importacionCsvSeleccionada = true;
    }
  }

  crearLista(): void {
    if (!this.deviceUrl) {
      this.messageService.add({
        severity: 'error', 
        summary: 'Error', 
        detail: this.translate.instant('SELECT_DEVICE_ERROR')
      });
      return;
    }

    if (this.nuevaLista.nombre === "" || this.nuevaLista.tipoLista === "" || this.nuevaLista.lista === "") {
      this.messageService.add({severity: 'error', summary: 'Error', detail: this.translate.instant('ALERT_FIELDS')})
      this.validar = true;
      return;      
    }
    
    this.nuevaLista.token = this.deviceUrl;
    this.contactosService.createLista(this.nuevaLista, this.archivoSeleccionado?this.archivoSeleccionado:null)
      .subscribe((response) => {
        const mensaje: string =  this.archivoSeleccionado?this.translate.instant('ALERT_MESSAGE_CSV'):this.translate.instant('ALERT_MESSAGE_NO_CSV')
        this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: mensaje});
        setTimeout(()=>{this.router.navigate(['/contact-list'], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
        queryParamsHandling: 'merge'})},2500)
      }, (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ALERT_ERROR_LIST')});
      });
  }

  regresar(deviceUrl: string, deviceName: string){
    this.router.navigate(['/contact-list'], { queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName },
    queryParamsHandling: 'merge' });
  }

  verificarSoloNumeros(texto: string): boolean {
    return this.soloNumerosValidacion.test(texto);
  }

}
